import { Grid } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

import { getChartData, getEmptyStateChart } from '../../../helpers/chartHelper';
import getColourSchemeBasedOnStatus from '../../../helpers/getColourSchemeBasedOnStatus';
import { Analytics } from '../../../hooks/useAnalyticsQuery';

const WorkshopRegisteredActivatedLineChart = (props: { data: Analytics; loadingDataInterval: Array<any> }) => {
  const { t } = useTranslation();
  const { data = {}, loadingDataInterval = [] } = props;

  const loadingData = getEmptyStateChart(loadingDataInterval, ['w_registered', 'w_activated']);
  const chartData = getChartData(data, ['w_registered', 'w_activated']);
  return (
    <Grid>
      <ResponsiveContainer aspect={3.1}>
        <LineChart
          width={500}
          height={300}
          data={chartData.length === 0 ? loadingData : chartData}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="label" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line
            isAnimationActive={true}
            animateNewValues={true}
            name={t(`controlling:charts.workshop.activated_vs_registered.registered.legend`)}
            type="monotone"
            dataKey="w_registered"
            stroke={getColourSchemeBasedOnStatus('registered')}
          />
          <Line
            strokeWidth={4}
            isAnimationActive={true}
            animateNewValues={true}
            name={t(`controlling:charts.workshop.activated_vs_registered.activated.legend`)}
            type="monotone"
            dataKey="w_activated"
            stroke={getColourSchemeBasedOnStatus('active')}
          />
        </LineChart>
      </ResponsiveContainer>
    </Grid>
  );
};

export default WorkshopRegisteredActivatedLineChart;
